import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import TimesheetService from '../../components/timesheet/TimesheetService';

const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle'

};

export const fetchEmployeeMapping = createAsyncThunk('employeeMapping', async () => {
    const response = await TimesheetService.getEmployeeMappings(true);
    return response;
});

export const EmployeeMappingSlice = createSlice({
    name: 'employeeMapping',
    initialState,
    reducers: {
        addEmployeeMappingConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToEmployeeMappingConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployeeMapping.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchEmployeeMapping.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
    }
});


export const selectEmployeeMapping = (state) => state.employeeMapping.data;
